import { BingoScheduleItem, PortletSettings } from '../types';

export const SET_BINGO_SCHEDULE_AND_LOBBY = 'SET_BINGO_SCHEDULE_AND_LOBBY';
export const SET_IS_BINGO_SCHEDULE_LOADED = 'SET_IS_BINGO_SCHEDULE_LOADED';
export const SET_PORTLET_SETTINGS = 'SET_PORTLET_SETTINGS';
export const RESET_BINGO_SCHEDULE = 'RESET_BINGO_SCHEDULE';

export const setBingoScheduleAndLobbyData = (gameData: Array<BingoScheduleItem>) => ({
    type: SET_BINGO_SCHEDULE_AND_LOBBY,
    payload: gameData
});

export const setIsBingoScheduleLoaded = (isLoaded: boolean) => ({
    type: SET_IS_BINGO_SCHEDULE_LOADED,
    payload: isLoaded
});

export const setPortletSettings = (portletSettings: PortletSettings) => ({
    type: SET_PORTLET_SETTINGS,
    payload: portletSettings
});

export const resetBingoSchedule = () => ({
    type: RESET_BINGO_SCHEDULE
});
